import { RoleEnum } from 'src/common/external/bambi-api/bambiApi';

export const baseUserTypes: RoleEnum[] = [
  'owner',
  'admin',
  'dispatcher',
  'associate',
];
